import { EditCodeProjectFormActions } from 'src/codeDelivery/components/EditCodeProjectForm';
import actionCreator, { Actions } from '@utils/actionCreator';
import {
  ModulesV1Service,
  WorkspaceIdV1,
  Cd4peApiError,
  handleApiRequest,
  UpdateModuleRequestV1,
  ModuleResponseV1,
  isInternalError,
  isCd4peApiError,
} from '@utils/api/cd4pe';
import { VcsActions } from '@utils/api/cd4pe/vcs/actions';
import { Dispatch } from 'react';
import * as at from './actionTypes';

export const editModuleActions = {
  editModuleStart: () => actionCreator(at.EDIT_MODULE_START),
  editModuleComplete: (payload: ModuleResponseV1) =>
    actionCreator(at.EDIT_MODULE_COMPLETE, payload),
  editModuleError: (error: Cd4peApiError) =>
    actionCreator(at.EDIT_MODULE_ERROR, error),
  editModuleWebhookError: (error: Cd4peApiError) =>
    actionCreator(at.EDIT_MODULE_WEBHOOK_ERROR, error),
};

export type EditModuleActions =
  | Actions<typeof editModuleActions>
  | VcsActions
  | EditCodeProjectFormActions;

export interface EditModulePayload {
  workspaceId: WorkspaceIdV1;
  moduleName: string;
  requestBody: UpdateModuleRequestV1;
}

export const editModule = async (
  dispatch: Dispatch<EditModuleActions>,
  repoPayload: EditModulePayload,
) => {
  const editModuleCall = async (payload: EditModulePayload) => {
    const repoResponse = await handleApiRequest(
      ModulesV1Service.updateModuleV1(payload),
    );

    if (isInternalError(repoResponse) && repoResponse.body.code === 'VCS') {
      dispatch(editModuleActions.editModuleWebhookError(repoResponse));
      return;
    }

    if (isCd4peApiError(repoResponse)) {
      dispatch(editModuleActions.editModuleError(repoResponse));
      return;
    }

    dispatch(editModuleActions.editModuleComplete(repoResponse));
  };

  await editModuleCall(repoPayload);
};
